import { render, staticRenderFns } from "./TopicItem.vue?vue&type=template&id=4b309aae&scoped=true"
import script from "./TopicItem.vue?vue&type=script&lang=js"
export * from "./TopicItem.vue?vue&type=script&lang=js"
import style0 from "./TopicItem.vue?vue&type=style&index=0&id=4b309aae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b309aae",
  null
  
)

export default component.exports